
import Main from "../components/Main";
import Unauthorized from "../components/Unauthorized";
import Vue from 'vue';
import Router from 'vue-router';
import GAApi from "../api/GA/GAApi";

Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [
        {
            path: "/",
            name: "Home",
            component: Main,
        },
        {
            path: "/unauthorized",
            name: "unauthorized",
            beforeEnter(to, from, next) {
                GAApi.GetAccessDeniedPage().then(result => {
                    window.location.replace(result.data.Url);
                });
            },
        }
    ]
})